import React from "react";

const TotalStores = ({ color = "#000000", size = "20", fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
    >
      <rect width="54" height="54" rx="8" fill="#D1FFE1" />
      <path
        d="M27.77 29.255L33.985 23.04L32.445 21.445L27.77 26.12L25.405 23.81L23.865 25.35L27.77 29.255ZM22.6 33.6C21.995 33.6 21.4771 33.3846 21.0463 32.9538C20.6154 32.5229 20.4 32.005 20.4 31.4V18.2C20.4 17.595 20.6154 17.0771 21.0463 16.6463C21.4771 16.2154 21.995 16 22.6 16H35.8C36.405 16 36.9229 16.2154 37.3538 16.6463C37.7846 17.0771 38 17.595 38 18.2V31.4C38 32.005 37.7846 32.5229 37.3538 32.9538C36.9229 33.3846 36.405 33.6 35.8 33.6H22.6ZM18.2 38C17.595 38 17.0771 37.7846 16.6463 37.3538C16.2154 36.9229 16 36.405 16 35.8V20.4H18.2V35.8H33.6V38H18.2Z"
        fill="#39C568"
      />
    </svg>
  );
};

export default TotalStores;
